import { render, staticRenderFns } from "./IncomingCallPresentation.vue?vue&type=template&id=06a458f7&"
import script from "./IncomingCallPresentation.vue?vue&type=script&lang=js&"
export * from "./IncomingCallPresentation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports